.item {
	position: relative;
	display: flex;
	align-items: center;
	gap: 6px;
	padding: 8px 10px;
	border-radius: var(--parrot-chat-radius);
	cursor: pointer;
	color: var(--parrot-chat-text-secondary);
	font-size: var(--parrot-chat-font-size-sm);
	transition: background 0.12s, color 0.12s;
}

.item:hover,
.menuOpen {
	background: var(--parrot-chat-menu-hover);
	color: var(--parrot-chat-text);
}

.itemActive {
	/* Accent left bar so the active row is distinct from the (similar) hover background. */
	background: var(--parrot-chat-surface-raised);
	color: var(--parrot-chat-text);
	box-shadow: inset 2px 0 0 var(--parrot-chat-accent);
}

.itemLabel {
	flex: 1;
	min-width: 0;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.kebab {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 26px;
	height: 26px;
	flex-shrink: 0;
	padding: 0;
	background: transparent;
	border: none;
	border-radius: var(--parrot-chat-radius);
	color: var(--parrot-chat-text-muted);
	cursor: pointer;
	opacity: 0;
	transition: opacity 0.12s, color 0.12s, background 0.12s;
}

.item:hover .kebab,
.itemActive .kebab,
.menuOpen .kebab,
.kebab:focus-visible {
	opacity: 1;
}

.kebab:hover {
	color: var(--parrot-chat-text);
	background: var(--parrot-chat-border-strong);
}

.kebab svg {
	width: 16px;
	height: 16px;
	fill: currentColor;
	stroke: none;
}

.renameInput {
	width: 100%;
	padding: 6px 8px;
	background: var(--parrot-chat-bg);
	border: 1px solid var(--parrot-chat-accent);
	border-radius: var(--parrot-chat-radius);
	color: var(--parrot-chat-text);
	font-family: inherit;
	font-size: var(--parrot-chat-font-size-sm);
	outline: none;
	box-shadow: 0 0 0 3px var(--parrot-chat-accent-glow);
}
